class FavoriteElement {
  constructor(payload) {
    this._payload = payload;
  }

  getId() { return this._payload.id; }
  getUserId() { return this._payload.user_id; }
  getSessionId() { return this._payload.session_id; }
  getItemId() { return this._payload.item_id; }
  getDateCreated() { return this._payload.date_created; }

  getPayload() {
    return this._payload;
  }
}

export default FavoriteElement;
